import React from 'react';
import { COCKPIT_TENANT } from './cockpit-data.jsx';
import { RepairActionModal } from './cockpit-health.jsx';
import { Icon } from './icons.jsx';
// Cockpit: Tab Ações Administrativas

const ACTION_CATEGORIES = [
  {
    id: 'acesso', label: 'Acesso', icon: 'users',
    actions: [
      { id: 'open-dashboard',  name: 'Abrir dashboard do tenant',   desc: 'Abre o painel do tenant em nova aba',               icon: 'externalLink', danger: false, requiresReason: false, confirmLabel: null },
      { id: 'login-as-owner',  name: 'Login como lojista',          desc: 'Inicia sessão impersonando o owner do tenant',       icon: 'switchUser',   danger: false, requiresReason: true,  confirmLabel: 'Iniciar sessão',   impact: 'Você terá acesso total à loja em nome do lojista. Todas as ações serão auditadas.' },
      { id: 'reset-password',  name: 'Resetar senha do owner',      desc: 'Envia e-mail de redefinição de senha ao owner',      icon: 'key',          danger: false, requiresReason: true,  confirmLabel: 'Resetar senha',    impact: 'O owner receberá um link de redefinição por e-mail. A sessão atual não será encerrada.' },
      { id: 'resend-invite',   name: 'Reenviar convite',            desc: 'Reenvia o e-mail de boas-vindas ao owner',           icon: 'mail',         danger: false, requiresReason: false, confirmLabel: null },
      { id: 'force-logout',    name: 'Forçar logout de todos',      desc: 'Invalida todas as sessões ativas do tenant',         icon: 'lock',         danger: true,  requiresReason: true,  confirmLabel: 'Forçar logout',    impact: 'Todos os usuários serão deslogados imediatamente. Trabalho não salvo pode ser perdido.' },
      { id: 'unlock-owner',    name: 'Desbloquear usuário owner',   desc: 'Remove bloqueio por excesso de tentativas de login', icon: 'userCheck',    danger: false, requiresReason: true,  confirmLabel: 'Desbloquear',      impact: 'O owner poderá fazer login novamente imediatamente.' },
    ],
  },
  {
    id: 'operacao', label: 'Operação', icon: 'store',
    actions: [
      { id: 'change-plan',      name: 'Alterar plano',              desc: 'Muda o plano de assinatura do tenant',              icon: 'edit',         danger: false, requiresReason: false, confirmLabel: null },
      { id: 'suspend',          name: 'Suspender comercialmente',   desc: 'Altera apenas o status comercial (billing)',          icon: 'suspend',      danger: true,  requiresReason: true,  confirmLabel: 'Suspender comercialmente', impact: 'Altera apenas o status comercial. Nesta fase, essa ação não bloqueia o acesso à loja. Para bloquear a operação, use Arquivar loja.' },
      { id: 'activate',         name: 'Reativar comercialmente',    desc: 'Restaura o status comercial para ativo',             icon: 'play',         danger: false, requiresReason: true,  confirmLabel: 'Reativar comercialmente',  impact: 'O status comercial volta para ativo. O status operacional não é alterado.' },
      { id: 'mark-overdue',     name: 'Marcar como inadimplente',   desc: 'Altera o status de pagamento para inadimplente',     icon: 'overdue',      danger: true,  requiresReason: true,  confirmLabel: 'Marcar inadimplente', impact: 'O status será alterado e o owner notificado sobre o débito.' },
      { id: 'end-trial',        name: 'Encerrar trial',             desc: 'Finaliza o período trial imediatamente',            icon: 'clock',        danger: true,  requiresReason: true,  confirmLabel: 'Encerrar trial',   impact: 'O trial será encerrado e o tenant precisará assinar um plano pago para continuar.' },
      { id: 'convert-trial',    name: 'Converter trial → pago',    desc: 'Migra o tenant para um plano pago sem trial',        icon: 'check',        danger: false, requiresReason: true,  confirmLabel: 'Converter',        impact: 'O tenant será migrado para um plano pago. Cobrança iniciada no próximo ciclo.' },
    ],
  },
  {
    id: 'reparos', label: 'Reparos', icon: 'wrench',
    actions: [
      { id: 'recreate-mapping',  name: 'Recriar TenantMapping',      desc: 'Recria o mapeamento tenant → schema',              icon: 'layers',       danger: false, requiresReason: true,  confirmLabel: 'Recriar',          impact: 'O TenantMapping será recriado. Pode causar breve indisponibilidade (< 5s).' },
      { id: 'recreate-role',     name: 'Recriar role Gerente',        desc: 'Recria a role Gerente com permissões do plano',    icon: 'users',        danger: false, requiresReason: true,  confirmLabel: 'Recriar role',     impact: 'A role Gerente será recriada com permissões padrão do plano atual.' },
      { id: 'sync-permissions',  name: 'Sincronizar permissões',      desc: 'Sincroniza todas as roles com o plano atual',      icon: 'refresh',      danger: false, requiresReason: false, confirmLabel: null },
      { id: 'recreate-site',     name: 'Recriar Site',                desc: 'Recria o objeto Site com configurações padrão',    icon: 'globe',        danger: false, requiresReason: true,  confirmLabel: 'Recriar site',     impact: 'O Site será recriado. Configurações personalizadas podem ser perdidas.' },
      { id: 'recreate-settings', name: 'Recriar StoreSettings',       desc: 'Recria StoreSettings com valores padrão',         icon: 'settings',     danger: false, requiresReason: true,  confirmLabel: 'Recriar',          impact: 'As configurações da loja serão resetadas para o padrão do plano.' },
      { id: 'validate-dns',      name: 'Validar domínio',             desc: 'Verifica propagação DNS do domínio customizado',   icon: 'globe',        danger: false, requiresReason: false, confirmLabel: null },
      { id: 'reindex',           name: 'Reindexar busca',             desc: 'Reconstrói o índice de busca do tenant',           icon: 'search',       danger: false, requiresReason: false, confirmLabel: null },
      { id: 'clear-cache',       name: 'Limpar cache do tenant',       desc: 'Invalida todo o cache do tenant',                 icon: 'refresh',      danger: false, requiresReason: false, confirmLabel: null },
      { id: 'full-diagnosis',    name: 'Rodar diagnóstico completo',   desc: 'Executa todos os health checks e gera relatório', icon: 'activity',     danger: false, requiresReason: false, confirmLabel: null },
    ],
  },
  {
    id: 'seguranca', label: 'Segurança', icon: 'shield',
    actions: [
      { id: 'revoke-tokens',     name: 'Revogar tokens públicos',     desc: 'Invalida todos os tokens de API pública do tenant', icon: 'key',          danger: true,  requiresReason: true,  confirmLabel: 'Revogar tokens',   impact: 'Todas as integrações usando os tokens serão interrompidas imediatamente.' },
      { id: 'rotate-token',      name: 'Rotacionar token integração', desc: 'Gera um novo token de integração para o tenant',   icon: 'refresh',      danger: false, requiresReason: true,  confirmLabel: 'Rotacionar',       impact: 'O token atual será invalidado e um novo token será gerado e exibido.' },
      { id: 'force-password',    name: 'Forçar troca de senha',       desc: 'Owner precisará trocar senha no próximo login',    icon: 'lock',         danger: false, requiresReason: true,  confirmLabel: 'Forçar',           impact: 'O owner será redirecionado para troca de senha na próxima autenticação.' },
      { id: 'block-impersonate', name: 'Bloquear impersonação',       desc: 'Impede login como lojista temporariamente',        icon: 'suspend',      danger: true,  requiresReason: true,  confirmLabel: 'Bloquear',         impact: 'Nenhum admin Tezus poderá fazer login como lojista até o bloqueio ser removido.' },
    ],
  },
];

// ── AdminActionCard ───────────────────────────────────────────────────────────
const AdminActionCard = ({ action, onExecute }) => {
  const [hover, setHover] = React.useState(false);
  return (
    <div
      onClick={() => onExecute(action)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', borderRadius: 8, cursor: 'pointer', background: hover ? 'var(--bg-hover)' : 'transparent', transition: 'background 120ms' }}
    >
      <div style={{ width: 34, height: 34, borderRadius: 8, background: action.danger ? 'var(--danger-bg)' : 'var(--bg-subtle)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, color: action.danger ? 'var(--danger)' : 'var(--text-secondary)' }}>
        <Icon name={action.icon} size={16} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 500, color: action.danger ? 'var(--danger)' : 'var(--text)', marginBottom: 2 }}>{action.name}</div>
        <div style={{ fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.4 }}>{action.desc}</div>
      </div>
      <Icon name="chevronRight" size={14} style={{ color: 'var(--text-muted)', flexShrink: 0, opacity: hover ? 1 : 0.3, transition: 'opacity 120ms' }} />
    </div>
  );
};

// ── CockpitActionsTab ─────────────────────────────────────────────────────────
const CockpitActionsTab = ({ cockpitData, onToast, onImpersonate, onChangePlan, onSuspend }) => {
  const [repairModal, setRepairModal] = React.useState(null);

  const handleExecute = (action) => {
    // Ações que disparam handlers externos
    if (action.id === 'open-dashboard') {
      window.open('https://' + (cockpitData?.tenant || COCKPIT_TENANT).domain, '_blank');
      onToast('Dashboard aberto em nova aba');
      return;
    }
    if (action.id === 'login-as-owner') { onImpersonate(); return; }
    if (action.id === 'change-plan')    { onChangePlan();  return; }
    if (action.id === 'suspend')        { onSuspend();     return; }
    if (action.id === 'activate')       { onSuspend();     return; }

    // Ações imediatas (sem modal)
    if (!action.requiresReason && !action.danger) {
      const msgs = {
        'resend-invite':   'Convite reenviado para ' + (cockpitData?.tenant || COCKPIT_TENANT).ownerEmail,
        'sync-permissions':'Permissões sincronizadas com o plano Pro',
        'validate-dns':    'Validação DNS iniciada — aguarde propagação',
        'reindex':         'Reindexação de busca iniciada…',
        'clear-cache':     'Cache do tenant limpo com sucesso',
        'full-diagnosis':  'Diagnóstico completo iniciado…',
      };
      onToast(msgs[action.id] || `Ação "${action.name}" executada`);
      return;
    }

    // Ações sensíveis → modal
    setRepairModal({
      name:          action.name,
      impact:        action.impact || action.desc,
      requiresReason: action.requiresReason,
      danger:        action.danger,
      confirmLabel:  action.confirmLabel || 'Confirmar',
    });
  };

  const handleConfirm = (motivo) => {
    onToast(`"${repairModal.name}" executado com sucesso`);
    setRepairModal(null);
  };

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
      {ACTION_CATEGORIES.map(cat => (
        <div key={cat.id} className="card">
          <div className="card-head">
            <Icon name={cat.icon} size={15} style={{ color: 'var(--text-muted)' }} />
            <h3>{cat.label}</h3>
          </div>
          <div style={{ padding: '6px 0' }}>
            {cat.actions.map((action, i) => (
              <React.Fragment key={action.id}>
                {i > 0 && <div style={{ height: 1, background: 'var(--border)', margin: '0 16px' }} />}
                <AdminActionCard action={action} onExecute={handleExecute} />
              </React.Fragment>
            ))}
          </div>
        </div>
      ))}

      <RepairActionModal open={!!repairModal} action={repairModal} onClose={() => setRepairModal(null)} onConfirm={handleConfirm} />
    </div>
  );
};

export {
  CockpitActionsTab,
};
